import StepAlertLocksAgenda from '../components/alert-locks-agenda'

export default {
  StepAlertLocksAgenda
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/locks/resources/components.js